module.exports = __webpack_public_path__ + "img/img.345ab4c8.png";